<template>
  <v-sheet class="d-flex" id="scolarities-data-sheet">
    <v-card>
      <v-card-title>
        <h4>
          Scolarités
          <small
            v-if="$store.state.moduleApplications.currentApplication.application_data.scolarities.length == 0"
          >
            <i>(Pas de données)</i>
          </small>
        </h4>
      </v-card-title>
      <v-divider></v-divider>
      <v-list
        dense
        v-for="(scolarity, i) in $store.state.moduleApplications.currentApplication.application_data.scolarities"
        :key="scolarity.scolarity_id"
      >
        <v-subheader>Scolarité {{i + 1}}</v-subheader>
        <v-list-tile>
          <v-list-tile-content>
            <b>École</b>
          </v-list-tile-content>
          <v-list-tile-content class="align-end">{{ scolarity.scolarity_school }}</v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <b>Lieu</b>
          </v-list-tile-content>
          <v-list-tile-content class="align-end">{{ scolarity.scolarity_location }}</v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <b>Niveau</b>
          </v-list-tile-content>
          <v-list-tile-content class="align-end">{{ scolarity.scolarity_level }}</v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <b>Années</b>
          </v-list-tile-content>
          <v-list-tile-content class="align-end">{{ scolarity.scolarity_years }}</v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
      </v-list>
    </v-card>
  </v-sheet>
</template>

<script>
export default {
  name: 'scolarities-data-sheet'
}
</script>
